import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import { Circle } from '@bubble-ui/primitive-circle';
import Shape from '@bubble-ui/primitive-shape';
import Rect from '@bubble-ui/primitive-rect';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationUseOfProduct = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationUseOfProduct',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#EBD4FF",
    fillRule: "evenodd",
    d: "M90 24.059H9V9a4 4 0 0 1 4-4h73a4 4 0 0 1 4 4v15.059Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D9D9D9",
    d: "M9 24.059h81v67.47a4 4 0 0 1-4 4H13a4 4 0 0 1-4-4V24.06Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 19.721,
    cy: 14.529,
    r: 3.574,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 29.25,
    cy: 14.529,
    r: 3.574,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 38.779,
    cy: 14.529,
    r: 3.574,
    fill: "#00EDB6"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 19.059,
    height: 9.529,
    x: 63.794,
    y: 9.765,
    fill: "#DABAFF",
    rx: 2
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1379)",
    fillRule: "evenodd",
    d: "M90 91.53a4 4 0 0 1-4 4H14.386C11.41 95.53 9 93.441 9 90.863V24.06h81v67.47Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 49.5,
    cy: 59.794,
    r: 25.015,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 51.882,
    cy: 62.176,
    r: 25.015,
    fill: "url(#paint1_linear_5601_1379)"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 49.5,
    cy: 59.794,
    r: 22.515,
    stroke: "url(#paint2_linear_5601_1379)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#B2A6FF",
    d: "M63.794 59.03a4 4 0 0 1 4-4h.765v9.529h-.765a4 4 0 0 1-4-4v-1.53Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1379",
    x1: -9.498,
    x2: 92.037,
    y1: 36.45,
    y2: 104.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1379",
    x1: 42.353,
    x2: 73.324,
    y1: 52.647,
    y2: 84.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1379",
    x1: 61.412,
    x2: 34.015,
    y1: 81.235,
    y2: 39.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#9D95FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EBD4FF"
  }))));
};
ColoredIllustrationUseOfProduct.displayName = 'ColoredIllustrationUseOfProduct';
export default withProvisionalOverrideFromContext(ColoredIllustrationUseOfProduct);
//# sourceMappingURL=index.js.map